import { render, staticRenderFns } from "./CustomerHeaderMachines.component.vue?vue&type=template&id=7125d80a&"
import script from "./CustomerHeaderMachines.component.vue?vue&type=script&lang=ts&"
export * from "./CustomerHeaderMachines.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VListItem,VListItemContent,VListItemTitle})
